import { useSelector } from 'react-redux'
import { faCheck, faXmark } from '@fortawesome/pro-solid-svg-icons'
import { Divider } from 'antd'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import IconButton from '../Buttons/IconButton'

const DEFAULT_TITLE = {
  CONFIRM: 'modal.ok_button.confirm',
  CANCEL: 'modal.cancel_button'
}
const DEFAULT_ICON = {  
  CONFIRM: faCheck,
  CANCEL: faXmark
}

const ConfirmFormFooter = ({ cancelClassName = '', cancelIcon = DEFAULT_ICON.CANCEL, cancelTitle = DEFAULT_TITLE.CANCEL, confirmClassName = '', confirmIcon = DEFAULT_ICON.CONFIRM, confirmTitle = DEFAULT_TITLE.CONFIRM, disabled, divider, onCancel, onConfirm }) => {
  const t = useSelector(selectTranslate)

  return (
    <>
      {divider && (
        <Divider />
      )}
      <div className='flex-row'>
        <IconButton
          className={cancelClassName}
          text={t(cancelTitle)}
          icon={cancelIcon}
          type='neutral'
          onClick={onCancel}
        />

        <div className='flex-fill' />

        <IconButton
          className={confirmClassName}
          text={t(confirmTitle)}
          icon={confirmIcon}
          type='primary'
          disabled={disabled}
          onClick={onConfirm}
        />
      </div>
    </>
  )
}

export default ConfirmFormFooter
